import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import type { ArtworkMedium } from "../lib/artworkPaths";
import { InquireArtworkLink } from "./InquireArtworkLink";
import { ArtworkShareButton } from "./ArtworkShareButton";

export function ArtworkLightboxActions({
  artworkPageHref,
  exploreGalleryHref,
  showInquire = true,
  inquire,
  share,
}: {
  artworkPageHref: string;
  exploreGalleryHref?: string;
  showInquire?: boolean;
  inquire?: {
    medium: ArtworkMedium;
    id: string;
    name: string;
  };
  share?: {
    medium: ArtworkMedium;
    id: string;
    title: string;
    text?: string;
  };
}) {
  const { t } = useTranslation();

  return (
    <div className="mt-5 flex flex-col gap-2.5 sm:mt-6 sm:gap-3">
      <Link to={artworkPageHref} className="btn-accent text-center !text-xs">
        {t("artwork.viewPiece")}
      </Link>
      {share && (
        <ArtworkShareButton
          medium={share.medium}
          id={share.id}
          title={share.title}
          text={share.text}
          className="btn-secondary text-center !text-xs"
        />
      )}
      {exploreGalleryHref && (
        <Link to={exploreGalleryHref} className="btn-secondary text-center !text-xs">
          {t("home.featured.exploreGallery")}
        </Link>
      )}
      {showInquire && inquire && (
        <InquireArtworkLink
          medium={inquire.medium}
          id={inquire.id}
          name={inquire.name}
          className="btn-secondary text-center !text-xs"
        />
      )}
    </div>
  );
}
